import React from "react";

import { currentCountry } from "../utils/country";

const translations = {
  MN: { loading: "Уншиж байна" },
  UZ: { loading: "Yuklanmoqda" },
  KZ: { loading: "Загрузка" },
};

const t = translations[currentCountry];

const Loading = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="flex flex-col items-center">
        {/* Modern animated loader */}
        <div className="relative">
          {/* Outer ring */}
          <div className="w-16 h-16 rounded-full border-4 border-gray-200"></div>

          {/* Spinning arc */}
          <div className="absolute top-0 left-0 w-16 h-16 rounded-full border-4 border-transparent border-t-black animate-spin"></div>

          {/* Inner pulse dot */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <div className="w-2 h-2 bg-black rounded-full animate-pulse"></div>
          </div>
        </div>

        {/* Loading text with dots animation */}
        <div className="mt-6 flex items-center gap-1">
          <span className="text-sm font-medium text-gray-600 tracking-wide">{t.loading}</span>
          <span className="flex gap-0.5">
            <span className="w-1 h-1 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "0ms" }}></span>
            <span className="w-1 h-1 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "150ms" }}></span>
            <span className="w-1 h-1 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "300ms" }}></span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Loading;
